module.exports = __webpack_public_path__ + "img/52.d79367d2.png";